__turbopack_context__.v({
  "grid": "WhatYouGet-module__sVUyba__grid",
  "iconImage": "WhatYouGet-module__sVUyba__iconImage",
  "iconWrapper": "WhatYouGet-module__sVUyba__iconWrapper",
  "inner": "WhatYouGet-module__sVUyba__inner",
  "item": "WhatYouGet-module__sVUyba__item",
  "itemCaption": "WhatYouGet-module__sVUyba__itemCaption",
  "itemTitle": "WhatYouGet-module__sVUyba__itemTitle",
  "section": "WhatYouGet-module__sVUyba__section",
  "textStack": "WhatYouGet-module__sVUyba__textStack",
  "title": "WhatYouGet-module__sVUyba__title",
});
